import { render, staticRenderFns } from "./SVGProjectsDelete.vue?vue&type=template&id=5d9a9f3c&scoped=true&"
import script from "./SVGProjectsDelete.vue?vue&type=script&lang=js&"
export * from "./SVGProjectsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a9f3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9a9f3c')) {
      api.createRecord('5d9a9f3c', component.options)
    } else {
      api.reload('5d9a9f3c', component.options)
    }
    module.hot.accept("./SVGProjectsDelete.vue?vue&type=template&id=5d9a9f3c&scoped=true&", function () {
      api.rerender('5d9a9f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGProjectsDelete.vue"
export default component.exports